import React from 'react';

const ServiceBoxRegular = ({
  isHaveBadge,
  badgeText,
  backgroundColorProperty,
  actionName,
  backgroundImage,
  backgroundImageUrl,
  callback,
  badgeColorProperty,
  badgeBackgroundColorProperty,
  context,
  action,
  actionUrl,
  isNeedMarginLeft,
}) => {
  // Helper to check for valid image extension
  const hasImageExtension = (url) => {
    if (!url || typeof url !== 'string') return false;
    return /\.(jpg|jpeg|png|gif|webp|svg|bmp|avif|pdf)(\?.*)?$/i.test(url);
  };

  const selectedImage = backgroundImage || backgroundImageUrl;
  const showImage = hasImageExtension(selectedImage);

  return (
    <>
      <div
        className='serviceBoxRegular'
        style={isNeedMarginLeft ? {marginLeft: 20} : {}}
        onClick={() => (action ? callback(action) : callback(actionUrl))}>
        <div className='item-block' style={{backgroundColor: backgroundColorProperty}}>
          {isHaveBadge && (
            <div className='item-badge' style={{backgroundColor: badgeBackgroundColorProperty, color: badgeColorProperty}}>
              {badgeText}
            </div>
          )}
          {showImage && <div className='item-image' style={{backgroundImage: `url(${selectedImage})`}}></div>}
          <div className='item-title'>{actionName}</div>
        </div>
      </div>
    </>
  );
};
export default ServiceBoxRegular;
